import { useEffect, useRef, useState } from 'react';
import { AwsRum, AwsRumConfig } from 'aws-rum-web';

import { APP_VERSION, APP_BUILD } from '@/appVersion';

import { useDashboardConfig } from '@/hooks/useDashboardConfig';

export function useInitAwsRum() {
  const isInit = useRef(false);
  const [awsRum, setAwsRum] = useState<AwsRum | null>(null);

  const config = useDashboardConfig();
  const rumConfig = config?.settings?.monitoring?.rum;

  useEffect(() => {
    if (rumConfig && !isInit.current && !!config?.site.name && config.site.environment) {
      try {
        const awsRumconfig: AwsRumConfig = {
          sessionSampleRate: 1,
          endpoint: rumConfig.endpoint,
          telemetries: ['errors', ['http', { recordAllRequests: true }]],
          allowCookies: false,
          enableXRay: false,
          signing: false,
          alias: rumConfig.alias,
          sessionAttributes: {
            applicationVersion: `${APP_VERSION}-${APP_BUILD}`,
            applicationClient: config.site.name,
            applicationEnv: config.site.environment,
          },
        };

        const APPLICATION_ID: string = rumConfig.appId;
        const APPLICATION_VERSION: string = rumConfig.appVersion || '1.0.0';
        const APPLICATION_REGION: string = rumConfig.appRegion;

        const rum: AwsRum = new AwsRum(APPLICATION_ID, APPLICATION_VERSION, APPLICATION_REGION, awsRumconfig);

        setAwsRum(rum);
        isInit.current = true;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
      } catch (error) {
        // Ignore errors thrown during CloudWatch RUM web client initialization
      }
    }
  }, [rumConfig, isInit, setAwsRum, config?.site?.environment, config?.site?.name]);

  return awsRum;
}
